import application from '@/app'

application.mount('#app')
